import React, { Component } from 'react';
import { connect, ResolveThunks } from 'react-redux';
import LockOpen from '@mui/icons-material/LockOpen';
import LockOutline from '@mui/icons-material/LockOutlined';
import { IconButton, Tooltip } from '@mui/material';

import { lockJob, unlockJob } from '../../actions/job';

interface OwnProps {
  readonly isLocked: boolean;
}
type DispatchProps = ResolveThunks<typeof actionCreators>;
type Props = OwnProps & DispatchProps;

class LockTool extends Component<Props> {
  toggleLockStatus = async () => {
    if (this.props.isLocked) {
      await this.props.unlockJob();
    } else {
      await this.props.lockJob();
    }
  };

  render() {
    return (
      <Tooltip disableInteractive disableFocusListener id="lock-status-tooltip" title="Job Lock Status">
        <IconButton onClick={this.toggleLockStatus}>
          {this.props.isLocked ? <LockOutline sx={{ color: 'primary.main' }} /> : <LockOpen sx={{ color: '#fff' }} />}
        </IconButton>
      </Tooltip>
    );
  }
}

const actionCreators = {
  unlockJob,
  lockJob,
};

export default connect(null, actionCreators)(LockTool);
